import { Alert, AlertColor, Snackbar } from '@mui/material';

interface IAlertaSnackBarProps {
  open: boolean;
  severity: AlertColor;
  message: string;
  handleClose: () => void;
}

export const AlertaSnackBar: React.FC<IAlertaSnackBarProps> = ({
  open,
  severity,
  message,
  handleClose,
}) => {
  return (
    <Snackbar open={open} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} autoHideDuration={6000} onClose={handleClose}>
      <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>);
};